import React from "react";
import PropTypes from "prop-types";
import { FieldLabel, SelectField, Input } from "react-invenio-forms";
import { i18next } from "@translations/up/i18next";
import { Grid, Divider } from "semantic-ui-react";

import { AdditionalTitlesField } from "../AdditionalTitlesField";

// FIXME: this should be a vocabulary instead
const frequencyOptions = [
  { text: "Annually", value: "Annually" },
  { text: "Bi-Annually", value: "Bi-Annually" },
  { text: "Quarterly", value: "Quarterly" },
  { text: "Monthly", value: "Monthly" },
  { text: "Bi-Monthly", value: "Bi-Monthly" },
  { text: "Weekly", value: "Weekly" },
  { text: "Bi-Weekly", value: "Bi-Weekly" },
  { text: "Other", value: "Other" },
];

export const JournalField = ({ vocabularies, recordUI }) => {
  let fieldPath = "custom_fields.journal:journal";
  return (
    <>
      <FieldLabel
        htmlFor={fieldPath}
        icon="newspaper outline"
        label={i18next.t("Journal")}
      />
      <Divider fitted />
      <Grid padded>
        <Grid.Column width="16">
          <Input fieldPath={`${fieldPath}.title`} label={i18next.t("Title")} />
          <label className="helptext mb-0">
            {i18next.t("Title of the journal in which the article was published")}
          </label>
        </Grid.Column>
        <Grid.Column width="16">
          <AdditionalTitlesField
            options={vocabularies.metadata.titles}
            fieldPath={`${fieldPath}.alternative_titles`}
            recordUI={recordUI}
          />
        </Grid.Column>
        <Grid.Column width="4">
          <Input
            fieldPath={`${fieldPath}.issn`}
            label={i18next.t("ISSN")}
            placeholder={i18next.t("ie.g. 2077-9550")}
          />
          <label className="helptext mb-0">
            {i18next.t("International Standard Serial Number")}
          </label>
        </Grid.Column>
        <Grid.Column width="6">
          <Input
            fieldPath={`${fieldPath}.volume`}
            label={i18next.t("Volume")}
            placeholder={i18next.t("e.g. 645")}
          />
        </Grid.Column>
        <Grid.Column width="6">
          <Input
            fieldPath={`${fieldPath}.issue`}
            label={i18next.t("Issue")}
            placeholder={i18next.t("e.g. 7")}
          />
        </Grid.Column>
        <Grid.Column width="4">
          <Input
            fieldPath={`${fieldPath}.pages`}
            label={i18next.t("Page range or article number")}
            placeholder={i18next.t("e.g. 15-23 or A29")}
          />
        </Grid.Column>
        <Grid.Column width="6">
          <SelectField
            fieldPath={`${fieldPath}.frequency`}
            label={i18next.t("Frequency")}
            optimized
            options={frequencyOptions}
          />
        </Grid.Column>
        <Grid.Column width="6">
          <Input
            fieldPath={`${fieldPath}.place_of_publication`}
            label={i18next.t("Place of publication")}
            placeholder={i18next.t("e.g. New York, NY")}
          />
        </Grid.Column>
      </Grid>
    </>
  );
};

JournalField.propTypes = {
  vocabularies: PropTypes.object.isRequired,
  recordUI: PropTypes.object,
};

JournalField.defaultProps = {
  recordUI: undefined,
};
